// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.j6ZzKt {
  align-items: flex-start;
  background: var(--alert-info-background);
  border: 1px solid var(--status-info);
  border-radius: var(--radius-s);
  color: var(--text-neutral-dark);
  display: flex;
  gap: var(--spacing-1);
  padding: var(--spacing-1-5);
  position: absolute;
  right: 0;
  top: 0;
}

.PiTkgw {
  flex: 1;

  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  letter-spacing: 0px;
  line-height: 20px;
}

._bEcgI {
  background: none;
  border: none;
  color: var(--link-default);
  padding: 0;
  text-decoration: underline;
}

._bEcgI:hover {
  color: var(--link-hover);
}

.RxGKip {
  background: none;
  border: none;
  cursor: pointer;
  padding: var(--spacing-1-5);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.jCUD7y {
  font-size: 16px;
  color: var(--alert-info-close-icon-color);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/ProductServiceSurveyAlert/ProductServiceSurveyAlert.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,oCAAoC;EACpC,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,OAAO;;EAEP,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yCAAyC;AAC3C","sourcesContent":[".alert {\n  align-items: flex-start;\n  background: var(--alert-info-background);\n  border: 1px solid var(--status-info);\n  border-radius: var(--radius-s);\n  color: var(--text-neutral-dark);\n  display: flex;\n  gap: var(--spacing-1);\n  padding: var(--spacing-1-5);\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.alertText {\n  flex: 1;\n\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  letter-spacing: 0px;\n  line-height: 20px;\n}\n\n.alertLink {\n  background: none;\n  border: none;\n  color: var(--link-default);\n  padding: 0;\n  text-decoration: underline;\n}\n\n.alertLink:hover {\n  color: var(--link-hover);\n}\n\n.alertClose {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: var(--spacing-1-5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.alertCloseIcon {\n  font-size: 16px;\n  color: var(--alert-info-close-icon-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `j6ZzKt`,
	"alertText": `PiTkgw`,
	"alertLink": `_bEcgI`,
	"alertClose": `RxGKip`,
	"alertCloseIcon": `jCUD7y`
};
module.exports = ___CSS_LOADER_EXPORT___;
